import { Link } from "react-router-dom";
import { container } from "tsyringe";

import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";

import Button, { EButtonColor, EButtonSize, EButtonVariant } from "components/elements/Button";
import I18n from "components/materials/I18n";
import ModuleConfig from "configs/ModuleConfig";

import classes from "./classes.module.scss";

const modules = container.resolve(ModuleConfig).get().modules;

type IProps = {
	project: Pick<ProjectResponseResource, "id">;
};

export default function ViewProjectButton(props: IProps) {
	return (
		<Link to={modules.pages.Project.props.path.replace(":projectId", props.project.id)} className={classes["root"]}>
			<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} size={EButtonSize.SMALL} className={classes["button"]}>
				{I18n.trslt(I18n.asset.component.featured_project.button)}
			</Button>
		</Link>
	);
}
